module.exports = __webpack_public_path__ + "static/media/countdownL.4593834f.jpg";